import React from 'react';

import {TextTags} from 'typescript/types/TextTypes';

import './Text.scss';

interface IProps {
  tag: string;
  children: React.ReactNode;
  uppercase?: boolean;
  italic?: boolean;
  className?: string;
}

const Text = ({tag, children, uppercase, italic, className, ...rest}: IProps) => {
  const setUppercase = () => (uppercase ? 'text--uppercase' : '');
  const setItalic = () => (italic ? 'text--italic' : '');

  const textObject: {[key: string]: JSX.Element} = {
    [TextTags.H1]: (
      <h1 {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h1>
    ),
    [TextTags.H2]: (
      <h2 {...rest} className={` ${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h2>
    ),
    [TextTags.H3]: (
      <h3 {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h3>
    ),
    [TextTags.H4]: (
      <h4 {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h4>
    ),
    [TextTags.H5]: (
      <h5 {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h5>
    ),
    [TextTags.H6]: (
      <h6 {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </h6>
    ),
    [TextTags.P]: (
      <p {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </p>
    ),
    [TextTags.SPAN]: (
      <span {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </span>
    ),
    [TextTags.SMALL]: (
      <small {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </small>
    ),
    [TextTags.PRE]: (
      <pre {...rest} className={`${setUppercase()} ${setItalic()} ${className}`}>
        {children}
      </pre>
    ),
  };

  return textObject[tag] || <>{children}</>;
};

Text.defaultProps = {
  uppercase: false,
  italic: false,
  className: '',
};

export default Text;
